import { useMemo } from 'react'
import { useSegment } from '../connect-context/tracking/useSegment'
import { createSegmentTracker } from '../utils/segment-tracking'

export const useTracking = () => {
  const segment = useSegment()

  const tracker = useMemo(() => {
    return createSegmentTracker(segment!)
  }, [segment])

  return tracker
}
